export enum KeyCode {
    printScreen = 44,
    escape = 27,
    up = 38,
    down = 40,
    enter = 13,
}
